import { render } from "./report_akt.vue?vue&type=template&id=ef806b18"
import script from "./report_akt.vue?vue&type=script&lang=js"
export * from "./report_akt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__